import { CLINICAL_FORM_PELUQUERIA } from './clinicalFormTemplates';

export const SALON_INTAKE_SCHEMA_VERSION = 1;

export function emptySalonIntake(header = {}) {
  return {
    form_template: CLINICAL_FORM_PELUQUERIA,
    schema_version: SALON_INTAKE_SCHEMA_VERSION,
    header: {
      folio: '',
      form_date: new Date().toISOString().slice(0, 10),
      ...header,
    },
    edad: '',
    phone_notes: '',
    allergies: '',
    sensitivities: '',
    medical_notes: '',
    hair_type: '',
    scalp_condition: '',
    previous_chemicals: '',
    salon_history: '',
    preferred_services: '',
    style_notes: '',
    photo_consent: false,
    treatment_consent: false,
    consent_name: '',
  };
}

export function mergeSalonIntake(saved) {
  const base = emptySalonIntake();
  if (!saved || typeof saved !== 'object') return base;
  return {
    ...base,
    ...saved,
    form_template: CLINICAL_FORM_PELUQUERIA,
    schema_version: SALON_INTAKE_SCHEMA_VERSION,
    header: { ...base.header, ...(saved.header || {}) },
    edad: String(saved.edad ?? '').trim(),
    phone_notes: String(saved.phone_notes ?? '').trim(),
    allergies: String(saved.allergies ?? '').trim(),
    sensitivities: String(saved.sensitivities ?? '').trim(),
    medical_notes: String(saved.medical_notes ?? '').trim(),
    hair_type: String(saved.hair_type ?? '').trim(),
    scalp_condition: String(saved.scalp_condition ?? '').trim(),
    previous_chemicals: String(saved.previous_chemicals ?? '').trim(),
    salon_history: String(saved.salon_history ?? '').trim(),
    preferred_services: String(saved.preferred_services ?? '').trim(),
    style_notes: String(saved.style_notes ?? '').trim(),
    photo_consent: Boolean(saved.photo_consent),
    treatment_consent: Boolean(saved.treatment_consent),
    consent_name: String(saved.consent_name ?? '').trim(),
  };
}
